import request from '@utils/request';
import moment, { Moment } from 'moment';
import type { Dispatch } from 'redux';
import { JourneyParams } from 'shared-types/Common';

const PREFIX = '[ROOMS]';

export const FETCH_ROOM_RATE_AVAILABILITY_REQUEST = `${PREFIX} FETCH_ROOM_RATE_AVAILABILITY_REQUEST`;
export const FETCH_ROOM_RATE_AVAILABILITY_SUCCESS = `${PREFIX} FETCH_ROOM_RATE_AVAILABILITY_SUCCESS`;
export const FETCH_ROOM_RATE_AVAILABILITY_FAILURE = `${PREFIX} FETCH_ROOM_RATE_AVAILABILITY_FAILURE`;

export const fetchRoomRateAvailabilityRequest = {
  type: FETCH_ROOM_RATE_AVAILABILITY_REQUEST,
};

export const fetchRoomRateAvailabilitySuccess = (data) => ({
  type: FETCH_ROOM_RATE_AVAILABILITY_SUCCESS,
  payload: data,
});

export const fetchRoomRateAvailabilityFailure = (data) => ({
  type: FETCH_ROOM_RATE_AVAILABILITY_FAILURE,
  payload: data,
});

export const fetchRoomRateAvailability =
  (dispatch: Dispatch) =>
  (
    propertyId: number,
    {
      fromDate = moment(new Date()),
      adults = 2,
      children = 0,
      promoRateCode,
      childAges = {},
    }: JourneyParams,
    extendedDate?: Moment,
    useRateCode = false,
    rateCode = '',
    roomCode = ''
  ) => {
    const fromDateFormatted =
      (extendedDate && extendedDate.startOf('M').format('YYYY-MM-DD')) ||
      moment(fromDate).startOf('M').format('YYYY-MM-DD');
    const toDate =
      (extendedDate && extendedDate.add(2, 'M').endOf('M')) ||
      moment(fromDate).add(2, 'M').endOf('M');
    const toDateFormatted = toDate.format('YYYY-MM-DD');
    const childAgesValues = Object.values(childAges);
    const childAgesParam = childAgesValues.length
      ? { 'child-ages': childAgesValues.join(',') }
      : undefined;

    dispatch(fetchRoomRateAvailabilityRequest);
    const url = `${propertyId}/rooms/calendar/${adults}/${fromDateFormatted}/${toDateFormatted}/availability`;
    const params = {
      children,
      ...childAgesParam,
    };

    if (useRateCode && promoRateCode) {
      params['promo-rate-code'] = promoRateCode;
    }

    if (rateCode) {
      params['rate-code'] = rateCode;
    }

    if (roomCode) {
      params['room-code'] = roomCode;
    }

    return request.get(url, { params }).then(
      ({ data }) => {
        dispatch(fetchRoomRateAvailabilitySuccess(data));
      },
      (error) => {
        console.log(error);
        dispatch(fetchRoomRateAvailabilityFailure(error));
      }
    );
  };
